module.exports = __webpack_public_path__ + "img/0x580655e2c6d4fc125c0b2d37b2a3e56219bf9f78.4517503a.png";